import Layout from '@/layout/paycools-index.vue'
// import i18n from '@/lang'

export const onlinePaymentShowRouter = {
  path: '/onlinePayment',
  component: Layout,
  redirect: '/onlinePayment/paymentLink',
  name: 'Online_Transaction',
  meta: { title: 'online_payment', icon: 'payment-link' },
  children: [
    {
      path: 'paymentLink',
      name: 'Online_Transaction_Payment_Link',
      component: () => import('@/views/paycools/online-transaction/payment-link'),
      meta: {
        title: 'payment_link', noCache: false,
        auth: ['ROLE_AUTH_PAYMENT_LINK']
      }
    }
  ]
}
export const onlinePaymentHideRouter = {
  path: '/onlinePayment',
  component: Layout,
  redirect: '/onlinePayment/paymentLink',
  name: 'Online_Transaction',
  meta: { title: 'online_payment', icon: 'payment-link' },
  children: [
    {
      path: 'detail/payin/:id/:status',
      name: 'Online_Transaction_Detail_Payin',
      component: () => import('@/views/paycools/online-transaction/detail-payin'),
      meta: {
        title: 'reference_detail', noCache: false,
        auth: ['ROLE_AUTH_PAYMENT_LINK'],
        activeMenu: '/onlinePayment/paymentLink'
      },
      hidden: true
    },
    {
      path: 'detail/payin/linkTrans',
      name: 'Online_Transaction_Detail_Payin_Link_Trans',
      component: () => import('@/views/paycools/online-transaction/detail-link-payin-trans'),
      meta: {
        title: 'link_transaction_detail', noCache: false,
        auth: ['ROLE_AUTH_PAYMENT_LINK'],
        activeMenu: '/onlinePayment/paymentLink'
      },
      hidden: true
    }
  ]
}
export const onlinePayoutShowRouter = {
  path: '/onlinePayout',
  component: Layout,
  redirect: '/onlinePayout/payoutApproval',
  name: 'Online_Transaction',
  meta: { title: 'send_payments', icon: 'send-payment' },
  alwaysShow: true,
  children: [
    // {
    //   path: 'payoutApproval',
    //   name: 'Online_Transaction_Payout_Approval',
    //   component: () => import('@/views/paycools/online-transaction/payout-approval'),
    //   meta: {
    //     title: 'online_payout', noCache: false,
    //     auth: ['ROLE_AUTH_PAYMENT_LINK']
    //   }
    // },
    {
      path: 'largeValuePayment',
      name: 'Online_Large_Value_Payment',
      component: () => import('@/views/paycools/online-transaction/payout-value-page'),
      meta: {
        title: 'payout_payment', noCache: false,
        auth: ['AUTH_CODE_LARGE_CREATE_DISBURSEMENT', 'AUTH_CODE_STANDARD_DISBURSEMENT']
      }
    },
    {
      path: 'batchPayoutReference',
      name: 'Batch_Payout_Reference',
      component: () => import('@/views/paycools/online-transaction/batch-payout-reference-list.vue'),
      meta: {
        title: 'batch_payment_details', noCache: false,
        auth: ['AUTH_CODE_BATCH_PAYMENT']
      }
    },
    {
      path: 'batch/disbursement/detail/:id/',
      name: 'Batch_Disbursement_Reference_Detail',
      component: () => import('@/views/paycools/online-transaction/batch-disbursement-reference-detail'),
      meta: {
        title: 'reference_detail', noCache: false,
        auth: ['AUTH_CODE_BATCH_PAYMENT'],
        activeMenu: '/onlinePayout/batchPayoutReference'
      },
      hidden: true
    },
    {
      path: 'largePayoutApproval',
      name: 'Online_Large_Payout_Approval',
      component: () => import('@/views/paycools/online-transaction/large-payout-approval'),
      meta: {
        title: 'online_large_payout', noCache: false,
        auth: ['AUTH_CODE_LARGE_AMOUNT']
      }
    }
  ]
}

// export const onlinePayoutHideRouter = {
//   path: '/onlinePayout',
//   component: Layout ,
//   redirect: '/onlinePayout/payoutApproval',
//   name: 'Online_Transaction',
//   meta: { title: 'online_payout', icon: 'send-payment' },
//   children: [
//     {
//       path: 'detail/disbursement/:id/:status',
//       name: 'Online_Transaction_Detail_Disbursement',
//       component: () => import('@/views/paycools/online-transaction/detail-disbursement'),
//       meta: {
//         title: 'reference_detail', noCache: false,
//         auth: ['AUTH_CODE_TRANSACTION_STATISTICS'],
//         activeMenu: '/onlinePayout/payoutApproval'
//       },
//       hidden: true
//     }
//   ]
// }
